"use client";

// src/components/default/lightbulb.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var LightbulbIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `LightbulbIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `LightbulbIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M10.0003 17.6185C9.6659 17.6185 9.35634 17.5304 9.07162 17.3541C8.78691 17.1778 8.60021 16.9326 8.51153 16.6185H8.0003C7.70117 16.6185 7.44583 16.5128 7.2343 16.3012C7.02276 16.0897 6.91699 15.8344 6.91699 15.5352V12.6346C6.10396 12.1111 5.48404 11.4348 5.05722 10.6058C4.6304 9.77669 4.41699 8.90811 4.41699 8C4.41699 6.44553 4.95892 5.12635 6.04278 4.04248C7.12666 2.95862 8.44583 2.41669 10.0003 2.41669C11.5548 2.41669 12.874 2.95862 13.9578 4.04248C15.0417 5.12635 15.5836 6.44553 15.5836 8C15.5836 8.89743 15.3702 9.76335 14.9434 10.5977C14.5166 11.4322 13.8966 12.1111 13.0836 12.6346V15.5352C13.0836 15.8344 12.9778 16.0897 12.7663 16.3012C12.5548 16.5128 12.2994 16.6185 12.0003 16.6185H11.4682C11.3796 16.9326 11.1963 17.1778 10.9186 17.3541C10.6408 17.5304 10.3347 17.6185 10.0003 17.6185ZM8.0003 15.5352H12.0003V14.5032H8.0003V15.5352ZM8.0003 13.5993H12.0003V12.5833H8.0003V13.5993ZM7.20864 11.5H9.62851V9.03204L8.08845 7.49198C8.01794 7.42147 7.98135 7.33413 7.97868 7.22996C7.97601 7.12579 8.0126 7.03579 8.08845 6.95994C8.16431 6.88408 8.25299 6.84615 8.35447 6.84615C8.45596 6.84615 8.54463 6.88408 8.62049 6.95994L10.0003 8.33975L11.3801 6.95994C11.4506 6.88942 11.538 6.85283 11.6421 6.85017C11.7463 6.84749 11.8363 6.88408 11.9122 6.95994C11.988 7.03579 12.0259 7.12446 12.0259 7.22596C12.0259 7.32745 11.988 7.41612 11.9122 7.49198L10.3721 9.03204V11.5H12.792C13.3197 11.0694 13.7364 10.5521 14.042 9.94792C14.3475 9.34375 14.5003 8.69444 14.5003 8C14.5003 6.75 14.0628 5.6875 13.1878 4.8125C12.3128 3.9375 11.2503 3.5 10.0003 3.5C8.7503 3.5 7.6878 3.9375 6.8128 4.8125C5.9378 5.6875 5.5003 6.75 5.5003 8C5.5003 8.68056 5.65308 9.32639 5.95864 9.9375C6.26419 10.5486 6.68086 11.0694 7.20864 11.5Z"
          }
        )
      )
    );
  }
);
export {
  LightbulbIcon
};
